export const INPUT_DEBOUNCE = 500;
export const TOOLTIP_OPEN_DELAY = 750;
export const TOOLTIP_INTERACTIVE_CLOSE_DELAY = 150;

export const HINT_TOOLTIP_OPEN_DELAY = 300;
export const HINT_TOOLTIP_PADDING_X = 4;
export const HINT_TOOLTIP_PADDING_Y = 2;
